import { IStudyGroup } from 'models/study-group';
import { studyGroups} from '../data/study-group'

const getStudyGroup = (studyName: string) => studyGroups.find((studyGroup: IStudyGroup) => studyGroup.studyNames.includes(studyName)) || (null as any);

const StudyGroupService = {
    getStudyGroup,
}

export default StudyGroupService;